export const REQUEST_ID_STORAGE_KEY = 'requestId';
export const APP_URL_STORAGE_KEY = 'appUrl';
